
import context from '~/mixins/context'

export default {
  mixins: [context]
}
